import { frontendURL } from '../../../helper/URLHelper';
import AdsCampaigns from './pages/AdsCampaigns.vue';
import AdsLeads from './pages/AdsLeads.vue';
import AdsFunnel from './pages/AdsFunnel.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'manager'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/ads/campaigns'),
    name: 'ads_campaigns',
    component: AdsCampaigns,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/ads/ads_leads'),
    name: 'ads_leads',
    component: AdsLeads,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/ads/funnel'),
    name: 'ads_funnel',
    component: AdsFunnel,
    meta: commonMeta,
  }
];